
import React from "react";
import {useTranslation} from "react-i18next";

import BusinessDirectoryDescriptionContent from "@/app/pages/businessDirectory/description/DescriptionContent";
import { getParagraphs } from "@/app/pages/businessDirectory/description/Content";

const DescriptionBlock = ({ countryCode }) => {
	const {t} = useTranslation();

  const props = {
    businessDirectoryParagraphLink1Label: t("businessDirectory.businessDirectoryParagraphLink1Label"),
    businessDirectoryParagraphLink2: t("businessDirectory.businessDirectoryParagraphLink2"),
    businessDirectoryParagraphLink2Label: t("businessDirectory.businessDirectoryParagraphLink2Label"),
    businessDirectoryParagraphLink3: t("businessDirectory.businessDirectoryParagraphLink3"),
    businessDirectoryParagraphLink3Label: t("businessDirectory.businessDirectoryParagraphLink3Label"),
    countryCode,
  }
  const paragraphs = getParagraphs(props);

  const getContent = () => {
    // Inorder to resolve ts error the countryCodeCC is created
    const countryCodeCC = props.countryCode ?? "";

    if (["de", "at", "ch"].includes(countryCodeCC)) {
      return { "paragraph": paragraphs["de"], "title": "Firmenverzeichnis" };
    }

    if (countryCodeCC === "hu") {
      return { "paragraph": paragraphs["hu"], "title": "D&B Cégkereső" };
    }

    if (countryCodeCC === "pl") {
      return { "paragraph": paragraphs["pl"], "title": "Baza firm D&B" };
    }

    if (countryCodeCC === "us") {
      return { "paragraph": paragraphs["us"], "title": "Business Directory" };
    }

    return { "paragraph": [], "title": "Business Directory" };
  };

  return (
      <BusinessDirectoryDescriptionContent {...getContent()} />
  )
};



export default DescriptionBlock
